import { MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog } from 'mdb-react-ui-kit';
import React, { useContext, useEffect } from 'react';

import PropTypes from 'prop-types';
import { UserProfileContext } from '../../context/UserProfileProvider';
import { fetchUserProfile } from './../../utils/Common';
import UserProfile from './UserProfile';

const UserProfileModal = ({showUserProfileModal,setShowUserProfileModal,user, onDomainUsersUpdate, onUsersUpdate, isCheckout} ) => {

    const { tokenLoaded, setUid ,setAddresses, setPhones, setEmails,setUserProfile,setGroups} = useContext(UserProfileContext);
  
    useEffect(() => {
        if (showUserProfileModal && tokenLoaded ) {
          fetchUserProfile(setUserProfile, setUid, setAddresses, setEmails, setPhones, tokenLoaded,setGroups);
          
        }
      }, [showUserProfileModal, tokenLoaded, user, setUid, setAddresses, setPhones, setEmails, setUserProfile, setGroups]);
    
    return (
    
            <MDBModal staticBackdrop={true} closeOnEsc={false}
                animationDirection='right'
                open={showUserProfileModal}
               
            >
                 <MDBModalDialog centered={true} size='lg'>
                    <MDBModalContent>
                        <MDBModalBody >
                            <UserProfile
                          isCheckout={isCheckout}
                            setShowUserProfileModal={setShowUserProfileModal}
                            showUserProfileModal={showUserProfileModal}
                            user={user}
                            onDomainUsersUpdate={onDomainUsersUpdate}
                            onUsersUpdate={onUsersUpdate}
                            />
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
      
    );
};
UserProfileModal.propTypes = {
    showUserProfileModal: PropTypes.bool.isRequired,
    setShowUserProfileModal: PropTypes.func,
    user: PropTypes.object,
    onDomainUsersUpdate: PropTypes.func,
    onUsersUpdate: PropTypes.func,
    isCheckout: PropTypes.bool,
    
}
export default UserProfileModal;
